import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=02376951&scoped=true&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"
import style0 from "./contact.vue?vue&type=style&index=0&id=02376951&prod&lang=scss&scoped=true&"
import style1 from "./contact.vue?vue&type=style&index=1&id=02376951&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02376951",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/home/vsts/work/1/s/components/PageHeader.vue').default,ContactStandard: require('/home/vsts/work/1/s/components/contact/standard.vue').default})
